



















































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { SortableTableHeader } from "../generic-pms-table/SortableTableDirective";
import * as _ from "lodash";
import { DataOptions } from "vuetify";
import { ListModel } from "@/shared/models/listModel";
import DateField from "@/components/misc/DateField.vue";
import SortableHeadersTable from "@/components/generic-pms-table/SortableHeadersTable.vue";
import { VFinancialDocument } from "@/shared/models/VFinancialDocument";
import { formatOrderbyArray } from "@/shared/sortHelperFunctions";
import { saveFile } from "@/shared/saveFile";
import { Action, Getter } from "vuex-class";
import { FinancialDocumentType } from "@/shared/models/financialDocumentType";
import { FinancialDocumentStatus } from "@/shared/models/financialDocumentStatus";
import { CardType } from "@/shared/models/cardType";
import { PaymentMean } from "@/shared/models/paymentMean";
import FinancialDocumentModalForm from "./FinancialDocumentModalForm.vue";
import { TaxRateView } from "@/shared/models/taxRates";
import CreditCardInfoModal from "@/components/credit-card/CreditCardInfoModal.vue";
import NoData from "@/components/misc/NoData.vue";
import ReservationFormPaymentForm from "../reservation-form/ReservationFormPaymentForm.vue";
import {
  DistributionChannelTypesEnum,
  PaymentModel,
  PaymentSlipModel,
} from "../reservation-form/types";
import { FinancialSettingsType } from "@/store/modules/financial";
import { BusinessUnit } from "@/shared/models/businessUnit";
import CashiersReportExportModal from "@/components/finances/CashiersReport/CashiersReportExportModal.vue";
import PaymentsReport from "@/components/finances/PaymentsReport/PaymentsReport.vue";
import {
  CustomerTypeEnum,
  FinancialDocumentStatusEnum,
  FinancialDocumentTypesEnum,
} from "@/shared/models/enums.type";
import { enumToArray } from "@/shared/commonFunctions";
import CustomerLookup from "@/components/misc/CustomerLookup.vue";
import VCustomer from "@/shared/models/vCustomer";
import {
  SepaResponseModel,
  FinDocsForSEPA,
} from "@/shared/models/finDocsForSepaExport";
import SelectedItemsTable from "../misc/SelectedItemsTable.vue";
import { TenantTypesEnum, InvoiceStatusEnum, EInvoiceStatusEnum } from "@/shared/models/enums.type";
import {
  GlobalFilterProperty,
  UnitLevelOwners,
} from "@/store/modules/globalFilters";
import NumericInput from "../misc/NumericInput.vue";
import { parseStringToDateJS } from "@/shared/dateFormatUtils";
import { DistributionChannelType } from "@/shared/models/distributionChannelType";
import { SalesChannelView } from "@/shared/models/salesChannel";
import { Ota } from "@/shared/models/ota";
import BulkInvoiceGenerationModal from "@/components/finances/BulkInvoiceGeneration/BulkInvoiceGenerationModal.vue";
import { CashRegisterModel } from "@/shared/models/cashRegister";
import { JwtClaims } from "@/store/modules/auth";
import PaymentSlipModalForm from "./PaymentSlipModalForm.vue";
import LoadingOverlay from "@/components/misc/LoadingOverlay.vue";
import FormDescription from "@/components/misc/FormDescription.vue";
import { policyChecker } from "@/shared/roles";
import {
  FinancialDocumentFiscalizeResult,
  PaymentSlipViewModel,
} from "./FinancialDocumentFormParts/models";
import { EInvoiceResponseModel } from "@/shared/models/eInvoiceResponseModel";

export enum ExportTypeEnum {
  SEPA = 1,
  OwnersInvoices = 2,
  AgencyCommissions = 3,
  GuestInvoices = 4,
}

export enum ExportDownloadTypeEnum {
  SeparatePDFs = 1,
  SinglePDF = 2,
}

export enum ReportDateTypeEnum {
  IssueDate = 1,
  DeliveryDate = 2,
}

export enum ReportDownloadTypeEnum {
  SummaryPDF = 1,
  PerDocumentPDF = 2,
  Excel = 3,
}

export enum SEPAFilterEnum {
  All = 1,
  WithDuePayment = 2,
  AllPaid = 3,
}

export enum ExportSEPATypeEnum {
  OneOrderPerFinancialDocument = 1,
  OneOrderPerOwner = 2,
}

@Component({
  components: {
    SortableHeadersTable,
    DateField,
    FinancialDocumentModalForm,
    CreditCardInfoModal,
    NoData,
    ReservationFormPaymentForm,
    CashiersReportExportModal,
    PaymentsReport,
    CustomerLookup,
    SelectedItemsTable,
    NumericInput,
    BulkInvoiceGenerationModal,
    PaymentSlipModalForm,
    LoadingOverlay,
    FormDescription,
  },
})
export default class PagedFinancesTable extends Vue {
  settingsOpen = false;
  loading = true;

  @Prop({ default: false }) chargeCancellationDisabled?: boolean;
  @Prop({ default: false }) chargeCancellationLoading?: boolean;
  @Prop({ default: false }) invoiceStatusId?: number;

  @Prop({ default: false }) markAsOverridenLoading?: boolean;

  @Prop({ default: "page" }) type?: "page" | "reservationmodal";
  @Watch("type", { immediate: true })
  typeChanged(fresh: "page" | "reservationmodal") {
    if (fresh === "page") {
      this.headers = [...this.headers];
    } else {
      const reservationmodalIgnoredHeaders = ["propertyName"];
      this.headers = this.headers
        .filter((x) => reservationmodalIgnoredHeaders.indexOf(x.value) === -1)
        .map((x) => (x.value === "customerName" ? { ...x, active: false } : x));
    }
  }

  @Prop() reservationId?: number | null;
  @Watch("reservationId", { immediate: true })
  reservationIdChanged(fresh: number | null) {
    this.filters.reservationId = fresh;
  }
  @Prop() hasCreditCard?: boolean;

  // prettier-ignore
  @Action("codebooks/refreshFinancialDocumentTypes")
  refreshDocumentTypes?: () => Promise<void>;
  @Getter("codebooks/financialDocumentTypes")
  financialDocumentTypes?: FinancialDocumentType[];

  // prettier-ignore
  @Action("codebooks/refreshFinancialDocumentStatuses")
  refreshDocumentStatuses?: () => Promise<void>;
  @Getter("codebooks/financialDocumentStatuses")
  financialDocumentStatuses?: FinancialDocumentStatus[];

  // prettier-ignore
  @Action("codebooks/refreshCardTypes")
  refreshCardTypes?: () => Promise<void>;
  @Getter("codebooks/cardTypes") cardTypes?: CardType[];

  // prettier-ignore
  @Action("codebooks/refreshPaymentMeans")
  refreshPaymentMeans?: () => Promise<void>;
  @Getter("codebooks/paymentMeans") paymentMeans?: PaymentMean[];

  // prettier-ignore
  @Action("codebooks/refreshTaxRates")refreshTaxRates?: () => Promise<void>;
  @Getter("codebooks/taxRates") taxRates?: TaxRateView[];

  // prettier-ignore
  @Getter("financial/settings") storedSettings?: FinancialSettingsType;
  @Action("financial/refreshModel") refreshSettings?: () => Promise<void>;

  @Getter("businessUnit/activeBusinessUnit") activeBusinessUnit?: BusinessUnit;
  @Getter("businessUnit/availableBusinessUnits")
  availableBusinessUnits?: BusinessUnit[];

  @Getter("language/language") language?: string;

  @Getter("cashRegister/activeCashRegister")
  activeCashRegister?: CashRegisterModel;

  @Getter("globalFilters/filteredProperties")
  properties?: GlobalFilterProperty[];
  @Getter("globalFilters/properties") unitLevelOwners?: UnitLevelOwners[];

  @Action("codebooks/refreshDistributionChannelTypes")
  refreshDistributionChannelTypes?: () => Promise<void>;
  @Getter("codebooks/distributionChannelTypes")
  distributionChannelTypes?: DistributionChannelType[];

  @Action("codebooks/refreshOtas") refreshOtas?: () => Promise<void>;
  @Getter("codebooks/otas") otas?: Ota[];

  @Action("codebooks/refreshSalesChannels")
  refreshSalesChannels?: () => Promise<void>;
  @Getter("codebooks/salesChannels") salesChannels?: SalesChannelView[];

  @Getter("cashRegister/allCashRegisters")
  allCashRegisters?: CashRegisterModel[];

  @Getter("appParams/cashRegisterFeatureFlag")
  cashRegisterFeature?: boolean;

  @Getter("appParams/tenantEInvoiceIntegrationId")
  tenantEInvoiceIntegrationId?: number;

  @Getter("globalFilters/filteredProperties")
  filteredProperties?: GlobalFilterProperty[];
  @Action("globalFilters/refreshProperties")
  refreshProperties?: () => Promise<void>;

  @Getter("auth/claims") claims?: JwtClaims;

  @Watch("claims.roles", { immediate: true })
  rolesWatch() {
    this.headers = [
      {
        text: "VFinancialDocument.issueDate",
        value: "issueDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["issueDate"],
      },
      {
        text: "VFinancialDocument.documentType",
        value: "documentType",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["documentType"],
      },
      {
        text: "VFinancialDocument.status",
        value: "status",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["status"],
      },
      ...(this.cashRegisterFeature
        ? [
            {
              text: "VFinancialDocument.documentIdentifier",
              value: "documentIdentifier",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["documentIdentifier"],
            },
            {
              text: "VFinancialDocument.documentInternalIdentifier",
              value: "documentInternalIdentifier",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["documentInternalIdentifier"],
            },
          ]
        : [
            {
              text: "VFinancialDocument.documentNumberComplete",
              value: "documentNumberComplete",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["documentNumberComplete"],
            },
          ]),
      {
        text: "VFinancialDocument.customerName",
        value: "customerName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["customerName"],
      },
      {
        text: "VFinancialDocument.totalDueAmount",
        value: "totalDueAmount",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["totalDueAmount, totalDueAmountAltCurrency"],
      },
      {
        text: "VFinancialDocument.totalWithVat",
        value: "totalWithVat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["totalWithVat, totalWithVatAltCurrency"],
      },
      {
        text: "VFinancialDocument.vat",
        value: "vat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["vat, vatAltCurrency"],
      },
      {
        text: "VFinancialDocument.totalWithoutVat",
        value: "totalWithoutVat",
        active: false,
        default: false,
        class: "resize-header",
        exportHeaders: ["totalWithoutVat, totalWithoutVatAltCurrency"],
      },
      {
        text: "VFinancialDocument.paymentMeans",
        value: "paymentMeans",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["paymentMeans"],
      },
      {
        text: "VFinancialDocument.cardType",
        value: "cardType",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["cardType"],
      },
      {
        text: "VFinancialDocument.isFiscalized",
        value: "isFiscalized",
        active: true,
        default: false,
        class: "resize-header header-filter",
        exportHeaders: ["isFiscalized"],
      },
      ...(this.setsFiscalAsMain
        ? [
            {
              text: "VFinancialDocument.referenceDocument",
              value: "referenceDocumentIdentifier",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["referenceDocument"],
            },
          ]
        : [
            {
              text: "VFinancialDocument.referenceDocumentInternalIdentifier",
              value: "referenceDocumentInternalIdentifier",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["referenceDocumentInternalIdentifier"],
            },
          ]),
      {
        text: "VFinancialDocument.propertyName",
        value: "propertyName",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["propertyName, reservationId"],
      },
      {
        text: "VFinancialDocument.dueDate",
        value: "dueDate",
        active: true,
        default: false,
        class: "resize-header",
        exportHeaders: ["dueDate"],
      },
      ...(this.cashRegisterFeature
        ? [
            {
              text: "VFinancialDocument.CashRegister",
              value: "cashRegister",
              active: true,
              default: false,
              class: "resize-header",
              exportHeaders: ["CashRegister"],
            },
          ]
        : []),
      {
        text: "Actions",
        value: "actions",
        sortable: false,
        active: true,
        default: true,
        class: "resize-header",
        exportHeaders: [],
      },
    ];
  }

  async created() {
    const promises = [];

    if (
      (this.financialDocumentTypes?.length ?? 0) === 0 &&
      this.refreshDocumentTypes
    ) {
      promises.push(this.refreshDocumentTypes());
    }

    if ((this.taxRates?.length ?? 0) === 0 && this.refreshTaxRates) {
      promises.push(this.refreshTaxRates());
    }

    if (
      (this.financialDocumentStatuses?.length ?? 0) === 0 &&
      this.refreshDocumentStatuses
    ) {
      promises.push(this.refreshDocumentStatuses());
    }

    if ((this.cardTypes?.length ?? 0) === 0 && this.refreshCardTypes) {
      promises.push(this.refreshCardTypes());
    }

    if ((this.paymentMeans?.length ?? 0) === 0 && this.refreshPaymentMeans) {
      promises.push(this.refreshPaymentMeans());
    }

    if (this.refreshSettings) {
      promises.push(this.refreshSettings());
    }

    if (
      (this.distributionChannelTypes?.length ?? 0) === 0 &&
      this.refreshDistributionChannelTypes
    ) {
      promises.push(this.refreshDistributionChannelTypes());
    }

    if ((this.otas?.length ?? 0) === 0 && this.refreshOtas) {
      promises.push(this.refreshOtas());
    }

    if ((this.salesChannels?.length ?? 0) === 0 && this.refreshSalesChannels) {
      promises.push(this.refreshSalesChannels());
    }

    if ((this.properties?.length ?? 0) === 0 && this.refreshProperties) {
      promises.push(this.refreshProperties());
    }
    await Promise.all(promises);
  }

  options: DataOptions = {
    page: 1,
    itemsPerPage: 15,
    sortBy: ["financialDocumentId"],
    sortDesc: [true],
    groupBy: [],
    groupDesc: [],
    multiSort: false,
    mustSort: true,
  };

  initLoaded = false;
  @Watch("options", { deep: true })
  watchOptions(fresh: DataOptions, old: DataOptions) {
    if (!this.initLoaded || !_.isEqual(fresh, old)) {
      this.initLoaded = true;
      this.load();
    }
  }

  headers: SortableTableHeader[] = [];

  filters = {
    issueDateFrom: "",
    issueDateTo: "",
    dueDateFrom: "",
    dueDateTo: "",
    cardTypeId: null as number | null,
    documentNumberComplete: "",
    documentIdentifier: "",
    documentInternalIdentifier: "",
    customerName: "",
    referenceDocument: "",
    referenceDocumentInternalIdentifier: "",
    propertyName: "",
    reservationId: null as number | null,
  };

  documentTypeIds = [] as number[];
  documentTypeIdsForInvoiceExport = [
    FinancialDocumentTypesEnum.Racun,
    FinancialDocumentTypesEnum.RacunZaPredujam,
  ] as number[];
  paymentMeansIdsForInvoiceExport = [] as number[];
  propertyIdsForExport = [] as number[];
  statusIds = [] as number[];
  paymentMeansIds = [] as number[];
  cashRegisterIds = [] as number[];

  distributionChannel = null as number | null;
  otaOrSalesChannel = null as number | null;
  sepaExportErrorOpen = false;

  @Watch("filters", { deep: true })
  watchFilters(val: any, old: any) {
    if (_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("documentTypeIds")
  watchDocumentTypes(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("statusIds")
  watchStatus(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("paymentMeansIds")
  watchPaymentMeansIds(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("cashRegisterIds")
  watchCashRegisterIds(val: any, old: any) {
    if (!_.isEqual(val, old)) {
      this.options.page = 1;
      this.debouncedLoad();
    }
  }

  @Watch("exportPeriodForSepa", { immediate: false })
  exportPeriodForSepaChanged() {
    if (this.exportPeriodForSepa.length != 1) this.loadForSepa();
  }

  @Watch("distributionChannel", { immediate: false })
  distributionChannelChanged() {
    this.debouncedSepaLoad();
  }

  @Watch("otaOrSalesChannel", { immediate: false })
  otaOrSalesChannelChanged() {
    this.debouncedSepaLoad();
  }

  get issueDatePeriod() {
    const res = [
      this.filters.issueDateFrom
        ? this.filters.issueDateFrom.substring(0, 10) ?? ""
        : "",
      this.filters.issueDateTo
        ? this.filters.issueDateTo.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set issueDatePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.issueDateFrom = val.length > 0 ? val[0] : "";
      this.filters.issueDateTo = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.issueDateFrom = "";
      this.filters.issueDateTo = "";
    }
  }

  get dueDatePeriod() {
    const res = [
      this.filters.dueDateFrom
        ? this.filters.dueDateFrom.substring(0, 10) ?? ""
        : "",
      this.filters.dueDateTo
        ? this.filters.dueDateTo.substring(0, 10) ?? ""
        : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set dueDatePeriod(val: string[]) {
    if (val && _.isArray(val)) {
      this.filters.dueDateFrom = val.length > 0 ? val[0] : "";
      this.filters.dueDateTo = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.filters.dueDateFrom = "";
      this.filters.dueDateTo = "";
    }
  }

  get setsFiscalAsMain() {
    return this.storedSettings?.setFiscalNumberAsMain ?? false;
  }

  list: ListModel<VFinancialDocument> = {
    count: 0,
    result: [],
  };

  skey = 0;

  debouncedLoad = _.debounce(this.load, 500);
  debouncedSepaLoad = _.debounce(this.loadForSepa, 500);

  async load(): Promise<ListModel<VFinancialDocument>> {
    this.loading = true;
    return this.axios
      .get<ListModel<VFinancialDocument>>("/financialDocuments", {
        params: this.queryParams,
      })
      .then((res) => {
        this.list = res.data;
        return this.list;
      })
      .finally(() => (this.loading = false));
  }

  refreshSepa() {
    this.debouncedSepaLoad();
  }

  get disableMarkAsManuallyOverriden() {
    return (
      !this.reservationId ||
      this.reservationId === 0 ||
      this.invoiceStatusId === InvoiceStatusEnum.ManuallyOverriden
    );
  }

  get isTenantAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get defaultPeriod() {
    const currentDate = new Date();
    const startOfPastMonth = parseStringToDateJS(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth() - 1,
        1
      ).toLocaleDateString("en-US")
    );
    const endOfPastMonth = parseStringToDateJS(
      new Date(
        currentDate.getFullYear(),
        currentDate.getMonth(),
        0
      ).toLocaleDateString("en-US")
    );

    return [
      startOfPastMonth.toISOString().substring(0, 10),
      endOfPastMonth.toISOString().substring(0, 10),
    ];
  }

  get queryParams() {
    return {
      $skip: this.options.itemsPerPage * (this.options.page - 1),
      $top: this.options.itemsPerPage,
      $orderby: formatOrderbyArray(
        this.options.sortBy,
        this.options.sortDesc.map((x) => !x)
      ),
      $count: true,
      usePropertyFilter: this.type === "page",
      statusIds: this.statusIds.join(","),
      documentTypeIds: this.documentTypeIds.join(","),
      paymentMeansIds: this.paymentMeansIds.join(","),
      cashRegisterIds: this.cashRegisterIds.join(","),
      ...this.filters,
    };
  }

  exportToExcel() {
    this.loading = true;

    return this.axios
      .get("financialDocuments/export/excel", {
        params: {
          ...this.queryParams,
          $skip: 0,
          $top: null,
          headers: this.headers
            .filter((h) => h.active)
            .flatMap((h) => h.exportHeaders)
            .join(","),
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Finances.xlsx");
      })
      .finally(() => {
        this.loading = false;
      });
  }

  async downloadPdfDocument(item: VFinancialDocument) {
    this.loading = true;

    const res = await Vue.axios.get(
      `financialDocuments/${item.financialDocumentId}/pdfDocument`,
      {
        params: {
          $skip: 0,
          $top: null,
        },
        responseType: "blob",
      }
    );

    const groups = /filename=(?<filename>[^;]+);/.exec(
      res.headers["content-disposition"]
    )?.groups;
    saveFile(res.data, groups?.filename ?? "Finances.xlsx");

    this.loading = false;
  }

  get isTenantTypeAgency() {
    return this.tenantTypeId === TenantTypesEnum.Agency;
  }

  get allowedDistributionChannelTypes() {
    if (!this.distributionChannelTypes) {
      return [];
    }
    const types = _.cloneDeep(this.distributionChannelTypes);

    if (this.isTenantTypeAgency) {
      return types;
    } else {
      return types?.filter(
        (channel) =>
          channel.id != DistributionChannelTypesEnum.OwnersReservation
      );
    }
  }

  openPaymentSlip(documentTypeId: number) {
    this.paymentSlipModel = new PaymentSlipModel(
      documentTypeId,
      this.activeBusinessUnit?.id ?? 0,
      this.activeCashRegister?.id ?? 0
    );
    this.paymentSlipFormOpen = true;
  }

  editingOpen = false;
  autoDeleteDocument = false;
  documentId: number | null = null;
  newDocumentTypeId: FinancialDocumentTypesEnum =
    FinancialDocumentTypesEnum.Racun;

  async createNew(documentTypeId: number) {
    if (!this.storedSettings || !this.activeBusinessUnit) {
      return;
    }

    if (
      documentTypeId === FinancialDocumentTypesEnum.Isplatnica ||
      documentTypeId === FinancialDocumentTypesEnum.Uplatnica
    ) {
      this.openPaymentSlip(documentTypeId);
    } else {
      this.documentId = null;
      this.newDocumentTypeId = documentTypeId;
      this.autoDeleteDocument = false;
      this.editingOpen = true;
    }
  }

  rowDoubleClick(e: MouseEvent, { item }: { item: VFinancialDocument }) {
    this.edit(item);
  }
  async edit(item: VFinancialDocument) {
    if (!this.taxRates || this.taxRates.length === 0) return;

    if (
      item.typeId === FinancialDocumentTypesEnum.Isplatnica ||
      item.typeId === FinancialDocumentTypesEnum.Uplatnica
    ) {
      this.loading = true;

      Vue.axios
        .get<PaymentSlipViewModel>(
          "financialDocuments/GetPaymentSlip/" + item.financialDocumentId
        )
        .then((res) => {
          const result = res.data;
          const issueDate = result.transactionDateTime.substring(0, 10);
          const issueTime = result.transactionDateTime.substring(11, 16);

          this.paymentSlipModel = {
            id: item.financialDocumentId,
            documentNumber: result.documentNumber,
            documentInternalIdentifier: result.documentInternalIdentifier,
            documentIdentifier: result.documentIdentifier,
            documentTypeId: result.documentTypeId,
            transactionDate: issueDate,
            transactionTime: issueTime,
            customerId: result.customerId,
            customerName: result.customerName,
            amount: result.transactionAmount,
            currencyId: result.currencyId,
            transactionDescriptionId: result.transactionDescriptionId,
            additionalNoteForTransaction: result.additionalNoteForTransaction,
            cashRegisterId: result.cashRegisterId,
            businessUnitId: result.businessUnitId,
          } as PaymentSlipModel;
          this.paymentSlipFormOpen = true;
        })
        .finally(() => {
          this.loading = false;
        });
    } else {
      this.openDocument(item.financialDocumentId, false);
    }
  }

  openDocument(documentId: number, autoDelete = false) {
    this.documentId = documentId;
    this.autoDeleteDocument = autoDelete;
    this.editingOpen = true;
  }

  async fiscalize(item: VFinancialDocument) {
    if (!item || !item.fiscalizationFailed) {
      return;
    }

    try {
      this.loading = true;

      await this.axios
        .put(`financialDocuments/${item.financialDocumentId}/fiscalize`)
        .then((res) => {
          const result = res.data as FinancialDocumentFiscalizeResult;

          if (result.fiscalized) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t("FinancialDocument.FiscalizationSuccess"),
              timeout: 5000,
            });
          } else {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: this.$t("FinancialDocument.FiscalizationFailed"),
              timeout: 5000,
            });
          }
        });
    } catch {
      this.$store.dispatch("showNotification", {
        color: "error",
        message: this.$t("FinancialDocument.FiscalizationFailed"),
        timeout: 5000,
      });
    } finally {
      this.loading = false;
      this.load();
    }
  }

  async cancel(item: VFinancialDocument) {
    if (!this.taxRates || this.taxRates.length === 0) return;

    this.loading = true;

    await Vue.axios
      .post<number>(`financialDocuments/${item.financialDocumentId}/cancel`, {
        businessUnitId: this.activeBusinessUnit?.id ?? null,
        cashRegisterId: this.activeCashRegister?.id ?? null,
      })
      .then((res) => this.openDocument(res.data, true))
      .finally(() => (this.loading = false));
  }

  deleteItem(item: VFinancialDocument) {
    this.$store.dispatch("showNotification", {
      id: item.financialDocumentId,
      color: "warning",
      message: this.$t("DeleteConfirmationFinDocs"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.deleteItemConfirm(item.financialDocumentId);
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    });
  }
  deleteItemConfirm(id: number) {
    Vue.axios
      .delete(`/financialDocuments/${id}`)
      .then(() => {
        this.loading = true;
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("FinancialDocuments.DeleteSuccess"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.loading = false;
        this.load();
      });
  }

  refresh() {
    this.load();
  }

  modalSaved() {
    this.$emit("saved");
    this.load();
  }

  documentPaid() {
    this.$emit("paid");
  }

  paymentFormOpen = false;
  paymentModel = new PaymentModel();

  newPayment(item: VFinancialDocument) {
    this.paymentModel = new PaymentModel();
    this.paymentModel.customerId = item.customerId;
    this.paymentModel.paymentMeansId = item.paymentMeansId;
    this.paymentModel.cardTypeId = item.cardTypeId;
    this.paymentModel.financialDocumentId = item.financialDocumentId;
    this.paymentModel.reservationId = this.reservationId ?? null;
    this.paymentModel.amount =
      item.totalDueAmountAltCurrency ?? item.totalDueAmount;

    this.paymentFormOpen = true;
  }

  paymentSaved() {
    this.$emit("paymentSaved");
  }

  paymentsReportOpen = false;
  openPaymentsReport() {
    this.paymentsReportOpen = true;
  }

  cashiersReportExportOpen = false;
  openCashiersReportExport() {
    this.cashiersReportExportOpen = true;
  }

  bulkInvoiceGenerationModalOpen = false;
  openbulkInvoiceGenerationModal() {
    this.bulkInvoiceGenerationModalOpen = !this.bulkInvoiceGenerationModalOpen;
  }

  paymentSlipFormOpen = false;
  paymentSlipModel = null as PaymentSlipModel | null;

  fromDateErpExport = "";
  toDateErpExport = "";
  filteredBusinessUnits: BusinessUnit[] = [];

  exportErpOpen = false;

  openErpExport() {
    this.filteredBusinessUnits = this.availableBusinessUnits ?? [];
    this.exportBusinessUnitIds = this.filteredBusinessUnits.map(
      (unit) => unit.id
    );
    this.exportErpOpen = true;
  }

  get erpExportDisabled() {
    return this.fromDateErpExport == "";
  }

  get yesterday() {
    const date = new Date();
    date.setDate(date.getDate() - 1);
    return date.toISOString().substring(0, 10);
  }

  get exportErpDates() {
    const res = [
      this.fromDateErpExport
        ? this.fromDateErpExport.substring(0, 10) ?? ""
        : "",
      this.toDateErpExport ? this.toDateErpExport.substring(0, 10) ?? "" : "",
    ].filter((x) => !!x) as string[];
    return res;
  }

  set exportErpDates(val: string[]) {
    if (val && _.isArray(val)) {
      this.fromDateErpExport = val.length > 0 ? val[0] : "";
      this.toDateErpExport = val.length > 1 ? val[1] : "";
    }
    //reset value when user clears data
    else {
      this.fromDateErpExport = "";
      this.toDateErpExport = "";
    }
  }

  valueIsEffectively0(value: number) {
    return value < 0 && value > -0.005;
  }

  exportBusinessUnitIds = [] as number[];

  renderAsHtml = false;

  async exportERP() {
    this.loading = true;
    await this.axios
      .get(`financialDocuments/export/erpExport`, {
        params: {
          FromDate: this.fromDateErpExport,
          ToDate: this.toDateErpExport,
          businessUnitIds: this.exportBusinessUnitIds.join(","),
        },
      })
      .then((res) => {
        if (res.data.isSuccessful) {
          this.renderAsHtml = false;
          this.erpExportResults = {
            isSuccessful: res.data.isSuccessful,
            message: res.data.message.trim(),
          };

          if (res.data.fileResult && res.data.fileResult.length > 0) {
            const a = document.createElement("a");
            a.href =
              "data:" + res.data.mimeType + ";base64," + res.data.fileResult;
            a.download = res.data.fileName;
            a.click();
          }
        } else {
          //format message to unordered list
          if (
            res.data.messageDictionary &&
            Object.keys(res.data.messageDictionary).length > 0
          ) {
            let messageToShow = "";
            this.renderAsHtml = true;
            for (const [key, value] of Object.entries(
              res.data.messageDictionary
            )) {
              messageToShow += key + "<ul>";
              const stringValue = value as string[];
              for (const message of stringValue) {
                messageToShow += "<li>" + message + "</li>";
              }
              messageToShow += "</ul>";
            }
            this.erpExportResults = {
              isSuccessful: res.data.isSuccessful,
              message: messageToShow,
            };
          } else {
            this.renderAsHtml = false;
            this.erpExportResults = {
              isSuccessful: res.data.isSuccessful,
              message: res.data.message.trim(),
            };
          }
        }
      })
      .finally(() => {
        this.loading = false;
        this.exportErpOpen = false;
        this.exportErpResultsOpen = true;
      });
  }

  exportErpResultsOpen = false;
  erpExportResults = { isSuccessful: false, message: "" };

  sepaExportMessage = "";

  @Getter("appParams/tenantExportsSEPA") tenantExportsSEPA?: boolean;
  @Getter("appParams/tenantExportsOwnersInvoices")
  tenantExportsOwnersInvoices?: boolean;
  @Getter("appParams/tenantExportsAgencyCommissionInvoices")
  tenantExportsAgencyCommissionInvoices?: boolean;
  @Getter("appParams/tenantExportsGuestInvoices")
  tenantExportsGuestInvoices?: boolean;

  @Getter("appParams/typeId") tenantTypeId?: number;

  @Getter("appParams/tenantIsAllowedToAsyncBulkGenerateInvoices")
  tenantIsAllowedToAsyncBulkGenerateInvoices?: boolean;

  enumToArray = enumToArray;

  ExportTypeEnum = ExportTypeEnum;
  ExportDownloadTypeEnum = ExportDownloadTypeEnum;
  ExportSEPATypeEnum = ExportSEPATypeEnum;
  exportSepaOpen = false;
  invoiceExportOpen = false;
  exportDownloadType = ExportDownloadTypeEnum.SinglePDF;
  SEPAFilterEnum = SEPAFilterEnum;
  finDocFilterType = SEPAFilterEnum.WithDuePayment;
  filterByOwner = true;

  taxReportOpen = false;
  ReportDownloadTypeEnum = ReportDownloadTypeEnum;
  ReportDateTypeEnum = ReportDateTypeEnum;
  reportDateType = 1;
  reportDownloadType = 1;

  customerLookupOpen = false;
  selectingAllOwners = false;
  selectedOwners = [] as VCustomer[];
  selectedFinDocsForSepa = [] as FinDocsForSEPA[];
  exportPeriod = this.defaultPeriod as string[];
  exportPeriodForSepa = [] as string[];
  exportPeriodForTaxRecap = [] as string[];
  paymentDate = "";
  sepaOrder = null as number | null;
  sepaExportType = 1;

  exportInProgress = false;

  exportInvoices() {
    this.exportInProgress = true;
    this.axios
      .get("financialDocuments/export/exportInvoices", {
        params: {
          exportDownloadType: this.exportDownloadType,
          from: this.exportPeriod[0],
          to: this.exportPeriod[1],
          ownersIds: this.selectedOwners.map((x) => x.id).join(","),
          finDocTypeIds: this.documentTypeIdsForInvoiceExport.join(","),
          propertyIds: this.propertyIdsForExport.join(","),
          paymentMeanIds: this.paymentMeansIdsForInvoiceExport.join(","),
          filterByOwner: this.filterByOwner,
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Export.pdf");
      })
      .finally(() => {
        this.exportInProgress = false;
      });
  }

  exportSepa() {
    this.exportInProgress = true;

    const request = {
      finDocs: this.selectedFinDocsForSepa,
      sepaOrder: this.sepaOrder,
      paymentDate: this.paymentDate,
      exportType: this.sepaExportType,
    };
    this.axios
      .post("FinancialDocuments/ExportSepa", request)
      .then((res) => {
        if (res.data.fileResult && res.data.fileResult.length > 0) {
          const a = document.createElement("a");
          a.href =
            "data:" + res.data.mimeType + ";base64," + res.data.fileResult;
          a.download = res.data.fileName;
          a.click();
        }
        if (
          res.data.messageDictionary &&
          Object.keys(res.data.messageDictionary).length > 0
        ) {
          let messageToShow = "";
          this.renderAsHtml = true;
          for (const [key, value] of Object.entries(
            res.data.messageDictionary
          )) {
            messageToShow += key + "<ul>";
            const stringValue = value as string[];
            for (const message of stringValue) {
              messageToShow += "<li>" + this.$t(message) + "</li>";
            }
            messageToShow += "</ul>";
          }
          this.sepaExportMessage = messageToShow;
        }
      })
      .finally(() => {
        this.exportInProgress = false;
        if (this.sepaExportMessage.length > 0) {
          this.sepaExportErrorOpen = true;
        }
        this.refreshSepa();
      });
  }

  generateReport() {
    this.exportInProgress = true;
    this.axios
      .get("reports/GetTaxRecapitulationReport", {
        params: {
          dateFrom: this.exportPeriodForTaxRecap[0],
          dateTo: this.exportPeriodForTaxRecap[1],
          dateType: this.reportDateType,
          downloadType: this.reportDownloadType,
        },
        responseType: "blob",
      })
      .then((res) => {
        const groups = /filename=(?<filename>[^;]+);/.exec(
          res.headers["content-disposition"]
        )?.groups;
        saveFile(res.data, groups?.filename ?? "Report.pdf");
      })
      .finally(() => {
        this.exportInProgress = false;
      });
  }

  get disableTaxRecapExportButton() {
    return (
      this.exportPeriodForTaxRecap.length < 2 ||
      this.reportDateType == null ||
      this.reportDownloadType == null
    );
  }

  fkey = 0;
  @Watch("invoiceExportOpen")
  exportInvoicesOpenWatch(fresh: boolean, old: boolean) {
    if (fresh) {
      this.loadAllOwners();
      if (this.paymentMeans) {
        this.paymentMeansIdsForInvoiceExport = this.paymentMeans.map(
          (x) => x.id
        );
      }
      if (this.filteredProperties) {
        //we need a selection for 'empty property' so user can export decoupled finDocs as well
        const emptyProperty = {
          propertyId: 0,
          name: this.$t("NoProperty"),
        } as GlobalFilterProperty;

        this.propertyIdsForExport = [
          emptyProperty,
          ..._.sortBy(this.filteredProperties, (x) => x.name),
        ].map((x) => x.propertyId);
      }
      this.fkey++;
    }
    if (!fresh && old) {
      this.selectedOwners = [];
      this.documentTypeIdsForInvoiceExport = [
        FinancialDocumentTypesEnum.Racun,
        FinancialDocumentTypesEnum.RacunZaPredujam,
      ];
      this.fkey++;
    }
  }

  @Watch("exportSepaOpen")
  exportSepaOpenWatch(fresh: boolean, old: boolean) {
    if (fresh) {
      this.loadAllOwners();
    }
    if (!fresh && old) {
      this.selectedOwners = [];
      this.exportPeriod = this.defaultPeriod;
      this.cleanSepaFilters();
      this.fkey++;
    }
  }

  cleanSepaFilters() {
    this.exportPeriodForSepa = [];
    this.finDocsForSepa = [];
    this.selectedFinDocsForSepa = [];
    this.finDocFilterType = SEPAFilterEnum.WithDuePayment;
    this.paymentDate = "";
    this.distributionChannel = null;
    this.otaOrSalesChannel = null;
    this.sepaExportType = ExportSEPATypeEnum.OneOrderPerFinancialDocument;
  }

  get rules() {
    return {
      required: (value: any[]) =>
        (!!value && value.length > 0) || this.$t("Validation.Required"),
      requiredValue: (value: any) => !!value || this.$t("Validation.Required"),
    };
  }

  get vDialogMaxWidth() {
    return this.isTenantAgency ? 1200 : 490;
  }

  allOwners = [] as VCustomer[];

  finDocsForSepa = [] as FinDocsForSEPA[];

  loadAllOwners() {
    this.axios
      .get<ListModel<VCustomer>>("/customers", {
        params: {
          $top: 1000,
          $orderby: "name asc",
          customerTypeId: CustomerTypeEnum.Owner,
        },
      })
      .then((res) => {
        this.allOwners = res.data.result;
        this.filterOwnersForOwnerInvoices();
        if (this.invoiceExportOpen) {
          this.selectedOwners = this.allOwners;
          if (this.allOwners.length > 0) {
            this.filterByOwner = true;
          } else {
            this.filterByOwner = false;
          }
        }
      })
      .finally();
  }

  filterOwnersForOwnerInvoices() {
    const unitLevelOwners = [] as UnitLevelOwners[];
    this.properties?.forEach((x) =>
      x.unitLevelOwners.forEach((y) => {
        if (!unitLevelOwners.includes(y) && y.id) {
          unitLevelOwners.push(y);
        }
      })
    );

    this.allOwners = this.allOwners.filter((owner) => {
      return (
        this.properties?.find(
          (prop) => prop.ownerId && prop.ownerId === owner.id
        )?.isOwnerEligibleForIssuingOwnersInvoices ||
        unitLevelOwners.find((uLOwner) => uLOwner.id === owner.id)
          ?.isOwnerEligibleForIssuingOwnersInvoices
      );
    });
  }

  selectedItemsTableLoading = false;
  loadForSepa() {
    this.selectedItemsTableLoading = true;
    this.selectedFinDocsForSepa = [];
    this.axios
      .get<SepaResponseModel>("/financialDocuments/GetFinDocsForSepaExport", {
        params: {
          distributionChannel: this.distributionChannel,
          otaOrSalesChannel: this.otaOrSalesChannel,
          issueDateFrom: this.exportPeriodForSepa[0],
          issueDateTo: this.exportPeriodForSepa[1],
          finDocFilterType: this.finDocFilterType,
          paymentDate: this.paymentDate ? this.paymentDate : null,
        },
      })
      .then((res) => {
        this.finDocsForSepa = res.data.finDocs;
        this.sepaOrder = res.data.sepaOrderNumber;
      })
      .finally(() => {
        this.selectedItemsTableLoading = false;
      });
  }

  fetchSEPAOrderNumber() {
    this.selectedItemsTableLoading = true;
    this.axios
      .get<number>("/financialDocuments/GetOrderNumberForSepaExport", {
        params: {
          paymentDate: this.paymentDate,
        },
      })
      .then((res) => {
        this.sepaOrder = res.data;
      })
      .finally(() => {
        this.selectedItemsTableLoading = false;
      });
  }

  cancelSEPAPaymentsLoading = false;
  cancelSEPAPaymentsDialogOpen = false;
  cancelSEPAPaymentsDate = "";
  cancelSEPAPaymentsOrderNumber = null as number | null;
  cancelSEPAPaymentsFilename = "";

  cancelSEPAPaymentsFilenameChanged() {
    if (this.cancelSEPAPaymentsFilename) {
      const trimmed = this.cancelSEPAPaymentsFilename.trim();
      const withoutFileType = trimmed.split(".")[0];

      const parts = withoutFileType.split("-");
      if (parts.length === 3) {
        const orderNumber = Number.parseInt(parts[1]);
        const paymentDate = `${parts[2].substring(4)}-${parts[2].substring(
          2,
          4
        )}-${parts[2].substring(0, 2)}`;

        if (
          !isNaN(orderNumber) &&
          orderNumber > 0 &&
          !/[^0-9]/.test(parts[1]) &&
          this.isIsoDate(paymentDate)
        ) {
          this.cancelSEPAPaymentsOrderNumber = orderNumber;
          this.cancelSEPAPaymentsDate = paymentDate;
          return;
        }
      }
    }

    // reset field if parsing fails
    this.cancelSEPAPaymentsOrderNumber = null;
    this.cancelSEPAPaymentsDate = "";
  }

  get cancelSEPAFilenameValidation() {
    return this.cancelSEPAPaymentsFilename && !this.cancelSEPAPaymentsDate
      ? this.$t("SepaExport.CancelPayments.Filename.ParsingError")
      : "";
  }

  isIsoDate(value: string) {
    if (!/\d{4}-\d{2}-\d{2}/.test(value)) return false;
    const d = new Date(value);
    return (
      d instanceof Date &&
      !isNaN(d.getTime()) &&
      d.toISOString().substring(0, 10) === value
    ); // valid date
  }

  closeCancelSEPAPaymentsDialog() {
    this.cancelSEPAPaymentsDialogOpen = false;
    this.cancelSEPAPaymentsDate = "";
    this.cancelSEPAPaymentsOrderNumber = null;
    this.cancelSEPAPaymentsFilename = "";
  }

  cancelSEPAPaymentsConfirmation() {
    this.$store.dispatch("showNotification", {
      color: "warning",
      message: this.$t("SepaExport.CancelPayments.Confirmation"),
      actions: [
        {
          text: this.$t("Delete"),
          fun: () => {
            this.cancelSEPAPayments();
            return true;
          },
        },
        {
          text: this.$t("Cancel"),
          fun: () => {
            return true;
          },
        },
      ],
      timeout: 30000,
    });
  }

  cancelSEPAPayments() {
    this.cancelSEPAPaymentsLoading = true;
    this.axios
      .post("/financialDocuments/CancelPaymentsFromSEPAExport", {
        paymentDate: this.cancelSEPAPaymentsDate,
        sepaOrder: this.cancelSEPAPaymentsOrderNumber,
      })
      .then(() => {
        this.$store.dispatch("showNotification", {
          color: "success",
          message: this.$t("SepaExport.CancelPayments.Success"),
          timeout: 5000,
        });
        this.closeCancelSEPAPaymentsDialog();
      })
      .catch(() => {
        this.$store.dispatch("showNotification", {
          color: "error",
          message: this.$t("SepaExport.CancelPayments.Failed"),
          timeout: 5000,
        });
      })
      .finally(() => {
        this.cancelSEPAPaymentsLoading = false;
        this.refreshSepa();
      });
  }

  exportForSepa() {
    this.loadForSepa();
    this.exportSepaOpen = true;
    //this.exportType = ExportTypeEnum.SEPA;
    //this.invoiceExportOpen = true;
    this.skey++;
  }

  get disableSepaExport() {
    return (
      !this.paymentDate ||
      !this.sepaOrder ||
      this.sepaOrder < 1 ||
      this.selectedFinDocsForSepa.length < 1
    );
  }

  get disableInvoiceExport() {
    return (
      ((this.isTenantAgency || this.exportPeriod.length !== 2) &&
        (this.exportPeriod.length !== 2 ||
          (this.filterByOwner && this.selectedOwners.length == 0))) ||
      this.documentTypeIdsForInvoiceExport.length == 0 ||
      this.propertyIdsForExport.length == 0 ||
      this.paymentMeansIdsForInvoiceExport.length == 0
    );
  }

  get showExportForInvoices() {
    return (
      this.tenantExportsOwnersInvoices ||
      this.tenantExportsAgencyCommissionInvoices ||
      this.tenantExportsGuestInvoices
    );
  }

  get allCashRegistersSorted() {
    if (this.allCashRegisters) {
      const sortedActveCashRegisters = this.allCashRegisters
        .filter((x) => x.status)
        .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0));

      const sortedDeletedCashRegisters = this.allCashRegisters
        .filter((x) => !x.status)
        .sort((a, b) => (a.name !== b.name ? (a.name < b.name ? -1 : 1) : 0));

      return sortedActveCashRegisters.concat(sortedDeletedCashRegisters);
    }
    return [];
  }

  disableEInvoiceSendButton(value: VFinancialDocument) {
    if (value.eInvoiceStatusId != null && value.eInvoiceStatusId != undefined) {
      return (value.eInvoiceStatusId === EInvoiceStatusEnum.Unsuccessful || value.eInvoiceStatusId === EInvoiceStatusEnum.Canceled)
        ? false
        : true
    }
    return false;
  }

  showEInvoiceSendButton(item: VFinancialDocument) {
    return (
      this.tenantEInvoiceIntegrationId !== undefined &&
      this.tenantEInvoiceIntegrationId !== null &&
      this.tenantEInvoiceIntegrationId !== 0 &&
      item.customerIsLegalEntity &&
      (item.statusId === FinancialDocumentStatusEnum.Zakljucen ||
        item.statusId === FinancialDocumentStatusEnum.Placen ||
        item.statusId === FinancialDocumentStatusEnum.Storniran) &&
      (item.typeId === FinancialDocumentTypesEnum.Racun ||
        item.typeId === FinancialDocumentTypesEnum.RacunZaPredujam ||
        item.typeId === FinancialDocumentTypesEnum.Storno ||
        item.typeId === FinancialDocumentTypesEnum.RacunZaProviziju
      )
    )
  }

  sendEInvoice(id: number) {
    this.loading = true;
    this.axios
      .post<EInvoiceResponseModel>("FinancialDocuments/SendEInvoice", {financialDocumentId: id})
      .then((res) => {
          if (res.data.isSuccess) {
            this.$store.dispatch("showNotification", {
              color: "success",
              message: this.$t("EInvoice.Send.Success"),
              timeout: 5000,
            });
          }
          else if (!res.data.isSuccess && res.data.message !== undefined && res.data.message.length > 0) {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: res.data.message,
              timeout: 7000,
            });
          }
          else if(!res.data.isSuccess) {
            this.$store.dispatch("showNotification", {
              color: "error",
              message: this.$t("EInvoice.Send.Failed"),
              timeout: 7000,
            });
          }
      })
      .finally(() => {
        this.loading = false;
      });
  }

  selectAllBusinessUnits() {
    this.$nextTick(() => {
      if (this.checkedAllBusinessUnits) {
        this.exportBusinessUnitIds = [];
      } else {
        this.exportBusinessUnitIds = this.filteredBusinessUnits.map(
          (unit) => unit.id
        );
      }
    });
  }

  get checkedAllBusinessUnits() {
    return (
      this.exportBusinessUnitIds.length === this.filteredBusinessUnits.length
    );
  }

  get checkedSomeBusinessUnits() {
    return (
      this.exportBusinessUnitIds.length > 0 && !this.checkedAllBusinessUnits
    );
  }

  selectAllDocumentTypes() {
    this.$nextTick(() => {
      if (this.checkedAllDocumentTypes) {
        this.documentTypeIdsForInvoiceExport = [];
      } else {
        if (this.invoiceExportDocumentTypes) {
          this.documentTypeIdsForInvoiceExport =
            this.invoiceExportDocumentTypes.map((x) => x.id);
        }
      }
    });
  }

  selectAllProperties() {
    this.$nextTick(() => {
      if (this.checkedAllProperties) {
        this.propertyIdsForExport = [];
      } else {
        if (this.filteredProperties) {
          this.propertyIdsForExport = [0].concat(
            _.sortBy(this.filteredProperties, (x) => x.name).map(
              (x) => x.propertyId
            )
          );
        }
      }
    });
  }

  selectAllPaymentMeans() {
    this.$nextTick(() => {
      if (this.checkedAllPaymentMeans) {
        this.paymentMeansIdsForInvoiceExport = [];
      } else {
        if (this.paymentMeans) {
          this.paymentMeansIdsForInvoiceExport = this.paymentMeans.map(
            (x) => x.id
          );
        }
      }
    });
  }

  get checkedAllDocumentTypes() {
    return (
      this.documentTypeIdsForInvoiceExport.length ===
      this.invoiceExportDocumentTypes?.length
    );
  }

  get checkedSomeDocumentTypes() {
    return (
      this.documentTypeIdsForInvoiceExport.length > 0 &&
      !this.checkedAllDocumentTypes
    );
  }

  get checkedAllProperties() {
    return (
      this.propertyIdsForExport.length ===
      (this.filteredProperties?.length ?? 0) + 1
    );
  }

  get checkedSomeProperties() {
    return this.propertyIdsForExport.length > 0 && !this.checkedAllProperties;
  }

  get checkedAllPaymentMeans() {
    return (
      this.paymentMeansIdsForInvoiceExport.length === this.paymentMeans?.length
    );
  }

  get checkedSomePaymentMeans() {
    return (
      this.paymentMeansIdsForInvoiceExport.length > 0 &&
      !this.checkedAllPaymentMeans
    );
  }

  get isOwner() {
    return policyChecker("IS_OWNER_ROLE")(this.claims);
  }

  icon(checkedAll: boolean, checkedSome: boolean) {
    if (checkedAll) return "fa-check-square";
    if (checkedSome) return "fa-minus-square";
    return "fa-square";
  }

  get allowedFinancialDocumentTypes() {
    let types = _.cloneDeep(this.financialDocumentTypes);

    if (!this.isTenantAgency) {
      types = types?.filter(
        (document) =>
          document.id !== FinancialDocumentTypesEnum.VlasnikovRacun &&
          document.id !== FinancialDocumentTypesEnum.RacunZaProviziju
      );
    }
    if (!this.cashRegisterFeature) {
      types = types?.filter(
        (document) =>
          document.id !== FinancialDocumentTypesEnum.Uplatnica &&
          document.id !== FinancialDocumentTypesEnum.Isplatnica
      );
    }

    return types;
  }

  get invoiceExportDocumentTypes() {
    let types = _.cloneDeep(this.financialDocumentTypes);

    if (!this.isTenantAgency) {
      types = types?.filter(
        (x) =>
          x.id !== FinancialDocumentTypesEnum.VlasnikovRacun &&
          x.id !== FinancialDocumentTypesEnum.RacunZaProviziju
      );
    }

    types = types?.filter(
      (x) =>
        x.id !== FinancialDocumentTypesEnum.Uplatnica &&
        x.id !== FinancialDocumentTypesEnum.Isplatnica &&
        x.id !== FinancialDocumentTypesEnum.Otpremnica
    );

    return types;
  }

  get propertiesForExport() {
    if (!this.filteredProperties) return [] as GlobalFilterProperty[];
    //we need a selection for 'empty property' so user can export decoupled finDocs as well
    const emptyProperty = {
      propertyId: 0,
      name: this.$t("FinancialDocument.WithoutProperty"),
    } as GlobalFilterProperty;

    return [emptyProperty, ..._.sortBy(this.filteredProperties, (x) => x.name)];
  }
}
